import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '../../../style';
import { enums } from '../../../utils';
import PlusIcon from '../../../images/blue-plus-in-circle.svg';
import dayjs from 'dayjs';

type AddAbsenceLinkType = (p: {
  selectedDate: any;
  selectedCaseId: string;
  disabled?: boolean;
}) => React.ReactElement | null;

const LinkStyled = styled(Link)`
  color: ${colors.skyD2};
  font-weight: 600;
  float: right;
  margin: 20px 0;
`;

const LinkContent = styled.div`
  &:after {
    content: 'New absence';

    @media only screen and (max-width: 450px) {
      content: '';
    }
  }
`;

const DisabledLink = styled.span`
  color: ${colors.skyD2};
  font-weight: 600;
  float: right;
  margin: 20px 0;
  opacity: 0.5;
  cursor: not-allowed;
`;

const disabledTooltipText =
  "Intermittent absences can't be added to a closed case";

const AddAbsenceLink: AddAbsenceLinkType = ({
  selectedDate,
  selectedCaseId,
  disabled,
}) => {
  if (disabled) {
    return (
      <DisabledLink
        id="add-absence-link"
        aria-disabled="true"
        title={disabledTooltipText}
      >
        <LinkContent>
          <img
            src={PlusIcon}
            alt=""
            width="24"
            height="24"
            style={{ marginRight: 8 }}
          />
        </LinkContent>
      </DisabledLink>
    );
  }

  return (
    <LinkStyled
      id="add-absence-link"
      to={{
        pathname: `${enums.AppPaths.form}/intermittent-absence`,
        state: {
          task: { caseId: selectedCaseId },
          defaults: {
            startDate: dayjs(selectedDate).toDate(),
          },
        },
      }}
    >
      <LinkContent>
        <img
          src={PlusIcon}
          alt=""
          width="24"
          height="24"
          style={{ marginRight: 8 }}
        />
      </LinkContent>
    </LinkStyled>
  );
};

export default AddAbsenceLink;
